import {
  apiGetService,
  apiPostService,
  apiDeleteService,
  apiPatchService,
} from './common';

let nodeServiceUrl = process.env.REACT_APP_NODE_API_ENDPOINT;
let gitServiceBaseUrl = process.env.REACT_APP_DESIGNER_API_ENDPOINT;
let dataBuilderUrl = process.env.REACT_APP_DATABUILDER_ENDPOINT;

export const getProductPlatforms = async () => {
  return await apiGetService('/product_platforms');
};

export const getBusinessUnits = async () => {
  return await apiGetService('/business_units');
};

export const initiateProgramRepository = async (newProgramDetails) => {
  return await apiPostService({
    path: '/programs',
    payload: newProgramDetails,
    overriddenServiceURL: gitServiceBaseUrl,
  });
};

export const addProgram = async (newProgramDetails) => {
  return await apiPostService({
    path: '/programs',
    payload: newProgramDetails,
  });
};

export const editProgram = async (editProgramDetails) => {
  return await apiPatchService({
    path: '/programs',
    payload: editProgramDetails,
  });
};

export const requestProgramAccess = async (requestProgramDetails) => {
  return await apiPostService({
    path: '/program_request',
    payload: requestProgramDetails,
  });
};

export const sendEmailNotification = async (emailDetails) => {
  console.log('endpo', nodeServiceUrl);
  return await apiPostService({
    path: '/sendEmail',
    payload: emailDetails,
    overriddenServiceURL: nodeServiceUrl,
    attachBearerToToken: false,
  });
};
export const addPermissionToGitProgramRepo = async (
  userEmailList,
  programId,
) => {
  return await apiPostService({
    path: `/programs/${programId}/permissions`,
    overriddenServiceURL: gitServiceBaseUrl,
    payload: {
      id: programId,
      emails: userEmailList,
    },
  });
};

export const getMyPrograms = async (userId) => {
  return await apiGetService('/get_my_programs', {
    userId,
  });
};

export const getAllPrograms = async (activeFilters) => {
  return await apiGetService('/programs', { activeFilters });
};

// export const getAllProgramsSSP = async (
//   offset,
//   limit,
//   sortOrder,
//   sortBy,
//   searchBy,
//   searchText,
// ) => {
//   debugger;

//   let params = [
//     { key: offset, value: offset },
//     { key: limit, value: offset },
//     { key: sortOrder, value: offset },
//     { key: sortBy, value: offset },
//     { key: searchBy, value: offset },
//     { key: searchText, value: offset },
//   ].filter(x => x.value != null && x.value !== '');

//   return await apiGetService('/lazy_programs', ...params);
// };

// export const getAllProgramsSSP = async (
//   params
// ) => {
//   debugger;
//   return await apiGetService('/lazy_programs', params);
// };

export const getProgramDetails = async (
  programId,
  userId,
  accessRank,
  history = null,
) => {
  return await apiGetService(
    '/programs',
    {
      programId,
      userId,
      accessRank,
    },
    null,
  );
};

export const getProgramPendingAccessRequests = async (
  ownerId,
  programId,
  userId,
  accessRank,
) => {
  return await apiGetService('/program_request', {
    ownerId,
    programId,
    userId,
    accessRank,
  });
};

export const addUsersToProgram = async (
  programId,
  users,
  accessType = 1,
  userId,
  coOwner = false,
  accessRank,
) => {
  return await apiPostService({
    path: '/program_users',
    payload: {
      programId,
      userId,
      users,
      coOwner,
      accessRank,
      ...(accessType !== 'denied' && { accessLevel: accessType }),
    },
  });
};

export const deleteUserFromProgram = async (programId, userId) => {
  let res = await apiDeleteService({
    path: '/program_users',
    payload: {
      programId,
      userId,
    },
  });

  if (res && res.status === 200) {
    return res.data;
  }
};

export const deleteProgram = async (programId, userId, accessRank) => {
  let res = await apiDeleteService({
    path: '/programs',
    payload: {
      programId,
      userId,
      accessRank,
    },
  });

  if (res && res.status === 200) {
    return res.data;
  }
};

export const deleteProgramFromGit = async (programId) => {
  let res = await apiDeleteService({
    path: `/programs/${programId}`,
    overriddenServiceURL: gitServiceBaseUrl,
  });

  if (res && res.status === 200) {
    return res.data;
  }
};
export const migrateProgramToGit = async (programId, action) => {
  return await apiPostService({
    path: '/dataBuildDispatcher',
    overriddenServiceURL: dataBuilderUrl,
    attachBearerToToken: false,
    payload: {
      programCode: programId,
      action,
    },
  });
};
